import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/16/solid';

type SortIndicatorProps = {
  /** Sort direction for this column. */
  direction: 'asc' | 'desc';
  /** 1-based position within a multi-column sort. Omitted for a single-column sort. */
  order?: number;
};

/**
 * Compact sort-state mark for a column header: a solid chevron (asc / desc)
 * and, in a multi-column sort, the column's order number. Display-only — the
 * Products table ships a fixed multi-sort, so this communicates that order
 * rather than offering a click target. Rendered in the neutral icon color, not
 * the brand accent, which the Restrained palette reserves for action and
 * selection. Solid (not outline) so a 12px glyph still reads on a cheap LCD.
 */
export function SortIndicator({ direction, order }: SortIndicatorProps) {
  const Chevron = direction === 'asc' ? ChevronUpIcon : ChevronDownIcon;

  return (
    <span className="flex shrink-0 items-center gap-0.5 text-icon" aria-hidden="true">
      <Chevron className="h-3.5 w-3.5" />
      {order !== undefined && (
        <span className="text-xs font-semibold leading-none tabular-nums">{order}</span>
      )}
    </span>
  );
}
